import dayjs from "dayjs";
import { domAnimation, LazyMotion, m } from "framer-motion";
import { Link } from "react-router-dom";

import { articles } from "../../articles";
import useIsLoggedIn from "../../hooks/use-IsLoggedIn";
import Header from "../Profile/components/Header";
import Footer from "../StaticPages/Footer";

const EASE = [0.22, 1, 0.36, 1] as [number, number, number, number];
const NOOP = () => {};
const HTML_TAG_RE = /<[^>]+>/g;

function BlogCategories() {
	const isLoggedIn = useIsLoggedIn();

	return (
		<LazyMotion features={domAnimation} strict>
			<Header isLoggedIn={isLoggedIn} onChangeJobStatus={NOOP} />

			<main className="max-w-3xl mx-auto px-4 sm:px-6">
				{/* ── Header ────────────────────────────── */}
				<m.section
					className="pt-16 sm:pt-24 pb-10 sm:pb-14 border-b border-gray-200"
					initial={{ opacity: 0, y: 16 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.5, ease: EASE }}
				>
					<h1 className="font-plus-jakarta text-[clamp(2.5rem,6vw,4rem)] font-extrabold text-gray-900 tracking-tight leading-[1.05]">
						Articles
					</h1>
					<p className="font-inter text-lg text-gray-500 mt-4 max-w-xl leading-relaxed">
						Career insights and stories from Tanzania's job market.
					</p>
				</m.section>

				{/* ── Article List ──────────────────────── */}
				<div className="divide-y divide-gray-100">
					{articles.map((article, index) => (
						<m.div
							key={article.slug}
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{
								duration: 0.5,
								delay: 0.15 + index * 0.1,
								ease: EASE,
							}}
						>
							<Link to={`/articles/${article.slug}`} className="block group">
								<article className="py-10">
									{/* Metadata line */}
									<div className="flex items-center gap-3 mb-4">
										<span
											className="font-plus-jakarta text-xs font-bold text-blue-600/40"
											style={{ fontVariantNumeric: "tabular-nums" }}
										>
											{String(index + 1).padStart(2, "0")}
										</span>
										<span className="w-4 h-px bg-gray-300" aria-hidden="true" />
										<time className="font-inter text-xs font-medium text-gray-400 tracking-[0.15em] uppercase">
											{dayjs(article.date).format("MMM YYYY")}
										</time>
									</div>

									{/* Title */}
									<h2 className="font-plus-jakarta text-[clamp(1.25rem,3vw,1.75rem)] font-bold text-gray-900 leading-snug group-hover:text-blue-700 transition-colors duration-200">
										{article.title}
									</h2>

									{/* Excerpt */}
									<p className="font-inter text-base text-gray-500 leading-relaxed mt-3 max-w-2xl">
										{article.excerpt.replace(HTML_TAG_RE, "").slice(0, 240).trim()}...
									</p>
								</article>
							</Link>
						</m.div>
					))}
				</div>

				<div className="pb-16 sm:pb-24" />
			</main>

			<Footer />
		</LazyMotion>
	);
}

export default BlogCategories;
